import type { ExternalParticipant } from '@einwert/valuation-api-client'
import { HeaderParticipants, User } from 'ComponentLibrary'
import { type UserLinkCopy } from 'ComponentLibrary/src/piazza/text/UserLink/UserLink'
import { useTranslation } from 'react-i18next'

type MessageListTaskDrawerHeaderProps = {
    currentUser?: User
    replaceParticipantIds: (participantIds: number[]) => void
    setIsEditingParticipants: (isEditingParticipants: boolean) => void
    participantIds: number[]
    participantUsers: User[]
    orderObserverIds: string[] | undefined
    orderObservers: User[]
    externalParticipantUsers: ExternalParticipant[]
    userLinkCopy?: Partial<UserLinkCopy>
}

const MessageListHeaderThreadParticipants = ({
    currentUser,
    replaceParticipantIds,
    setIsEditingParticipants,
    participantIds,
    participantUsers,
    orderObserverIds,
    orderObservers,
    externalParticipantUsers,
    userLinkCopy,
}: MessageListTaskDrawerHeaderProps) => {
    const { t } = useTranslation('pages', { keyPrefix: 'orders.threadListPage.participantTooltips' })

    return (
        <HeaderParticipants
            currentUser={currentUser}
            replaceParticipantIds={replaceParticipantIds}
            setIsEditingParticipants={setIsEditingParticipants}
            participantIds={participantIds}
            participantUsers={participantUsers}
            observerIds={orderObserverIds}
            observerUsers={orderObservers}
            externalParticipantUsers={externalParticipantUsers}
            userBubbleTooltip={t('none')}
            isNotifiedTooltip={t('notified')}
            isNotNotifiedTooltip={t('notNotified')}
            copy={{
                participantGroup: t('participantGroup'),
                observerGroup: t('observerGroup'),
                observerTooltip: t('observerTooltip'),
            }}
            userLinkCopy={userLinkCopy}
        />
    )
}

export default MessageListHeaderThreadParticipants
